// extracted by LIB_CSS_EXTRACT_LOADER
import "./Collapse_module.css"
export default {"collapse":"collapse-_UWjTr","inner":"inner-lQXjeb"};